import {TenderProcurementsFormProps} from "../../../../types";
import {Form, InputNumber, Spin, UploadFile} from "antd";
import Uploader from "../../../../../../components/uploader/Uploader";
import * as BUCKETS from "../../../../../../enums/buckets";
import {useEffect, useState} from "react";
import "./style.less"
import TextArea from "antd/es/input/TextArea";

const TenderProcurementsForm = (props: TenderProcurementsFormProps) => {
  const {tenderProcurementsController} = props
  const {
    isLoading,
    form,
    submitButtonHandler,
    selectedTenderProcurementItem
  } = tenderProcurementsController

  const [file, setFile] = useState<UploadFile[]>([])

  useEffect(() => {
    if (selectedTenderProcurementItem) {
      form.setFieldsValue(selectedTenderProcurementItem)
      const {fileId} = selectedTenderProcurementItem
      const fileData = {
        uid: fileId,
        name: "",
        url: "",
        response: {$id: fileId}
      }
      setFile([fileData])
    } else {
      form.resetFields()
      setFile([])
    }
  }, [selectedTenderProcurementItem])

  return <Spin spinning={isLoading}>
    <Form form={form} layout="vertical" className="tenderProcurements_form" onFinish={(formData) => {
      const fileId = file[0]?.response.$id || ""
      submitButtonHandler({...formData, fileId})
    }}>
      <Form.Item name="year" label="Рік" rules={[{required: true}]}>
        <InputNumber style={{width: "100%"}}/>
      </Form.Item>
      <Form.Item name="title" label="Заголовок" rules={[{required: true}]}>
        <TextArea/>
      </Form.Item>
      <Form.Item label="Файл">
        <Uploader maxCount={1} bucketId={BUCKETS.MAIN} files={file} setFiles={setFile}/>
      </Form.Item>
    </Form>
  </Spin>
}
export default TenderProcurementsForm